/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_TypingInputs */

const en_us2_coach_typing = /** @type {(inputs: Coach_TypingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The trainer is typing`)
};

const pt_br2_coach_typing = /** @type {(inputs: Coach_TypingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O personal está digitando`)
};

const es_419_coach_typing = /** @type {(inputs: Coach_TypingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El entrenador está escribiendo`)
};

const pt_pt2_coach_typing = /** @type {(inputs: Coach_TypingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O treinador está a escrever`)
};

const fr_fr2_coach_typing = /** @type {(inputs: Coach_TypingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le coach écrit`)
};

const de_de2_coach_typing = /** @type {(inputs: Coach_TypingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Coach schreibt`)
};

const it_it2_coach_typing = /** @type {(inputs: Coach_TypingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il coach sta scrivendo`)
};

/**
* | output |
* | --- |
* | "The trainer is typing" |
*
* @param {Coach_TypingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_typing = /** @type {((inputs?: Coach_TypingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_TypingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_typing(inputs)
	if (locale === "es-419") return es_419_coach_typing(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_typing(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_typing(inputs)
	if (locale === "de-DE") return de_de2_coach_typing(inputs)
	if (locale === "it-IT") return it_it2_coach_typing(inputs)
	return en_us2_coach_typing(inputs)
});
export { coach_typing as "coach.typing" }